// extracted by mini-css-extract-plugin
export default {"wrapper":"data-large-block_wrapper__axvzS"};